"use strict";

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[typeof Symbol === "function" ? Symbol.iterator : "@@iterator"] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_native_router_flux_1 = require("react-native-router-flux");

var error_context_1 = require("../../../../../theming/pricing-system/error-context");

var errors_1 = require("../../../../../theming/pricing-system/errors");

var authentication_provider_1 = require("../../../../../utils/authentication/authentication-provider");

var get_all_drug_forms_1 = require("../../../api/v1/get-all-drug-forms");

var get_all_package_types_1 = require("../../../api/v1/get-all-package-types");

var get_pharmacy_group_1 = require("../../../api/v1/get-pharmacy-group");

var get_pharmacy_groups_1 = require("../../../api/v1/get-pharmacy-groups");

var login_1 = require("../../../api/v1/login");

var authentication_1 = require("../../../authentication/authentication");

var login_cancelled_error_1 = require("../../../errors/login-cancelled.error");

var login_in_progress_error_1 = require("../../../errors/login-in-progress.error");

var no_authentication_provider_error_1 = require("../../../errors/no-authentication-provider.error");

var logger_1 = require("../../../logging/logger");

var pricing_experience_navigator_screen_names_1 = require("../../../pricing-experience-navigator/pricing-experience-navigator.screen-names");

var busy_actions_1 = require("../../common/busy/busy.actions");

var error_message_show_action_1 = require("../../common/status/actions/error-message-show.action");

var get_all_drug_forms_response_action_1 = require("./get-all-drug-forms-response.action");

var get_all_package_types_response_action_1 = require("./get-all-package-types-response.action");

var get_pharmacy_groups_response_action_1 = require("./get-pharmacy-groups-response.action");

var login_incomplete_error_show_action_1 = require("./login-incomplete-error-show.action");

var login_response_action_1 = require("./login-response.action");

var pharmacy_group_select_action_1 = require("./pharmacy-group-select.action");

exports.loginAsyncAction = function (thisArg) {
  return busy_actions_1.showBusyWhile(function (dispatch, getState) {
    return __awaiter(void 0, void 0, void 0, function () {
      var state, config, domainDataSearchApi, userApi, authProvider, authResponse, accessToken, drugFormsResult, packageTypesResult, isAdmin, groups, currentGroup, ex_1;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            state = getState();
            config = state.config;
            domainDataSearchApi = config.apis.domainDataSearchApi;
            userApi = config.apis.userManagementApi;
            authProvider = authentication_1.Authentication.provider;
            _a.label = 1;

          case 1:
            _a.trys.push([1, 16,, 25]);

            logger_1.Logger.logStatusEvent(logger_1.LoggerEventActionType.authentication, logger_1.LoggerEventStatusType.request);

            if (!authProvider) {
              throw new no_authentication_provider_error_1.NoAuthenticationProviderError();
            }

            if (!!authProvider.isLoggedIn()) return [3, 3];
            return [4, login_1.login(authProvider)];

          case 2:
            _a.sent();

            _a.label = 3;

          case 3:
            return [4, authProvider.acquireToken()];

          case 4:
            authResponse = _a.sent();
            accessToken = authResponse.accessToken;
            return [4, get_all_drug_forms_1.getAllDrugForms(domainDataSearchApi, accessToken)];

          case 5:
            drugFormsResult = _a.sent();
            return [4, dispatch(get_all_drug_forms_response_action_1.getAllDrugFormsResponseAction(drugFormsResult))];

          case 6:
            _a.sent();

            return [4, get_all_package_types_1.getAllPackageTypes(domainDataSearchApi, accessToken)];

          case 7:
            packageTypesResult = _a.sent();
            return [4, dispatch(get_all_package_types_response_action_1.getAllPackageTypesResponseAction(packageTypesResult))];

          case 8:
            _a.sent();

            isAdmin = authentication_provider_1.AuthenticationProvider.isAdmin(authResponse);
            if (!isAdmin) return [3, 11];
            return [4, get_pharmacy_groups_1.getPharmacyGroups(userApi, accessToken)];

          case 9:
            groups = _a.sent();
            return [4, dispatch(get_pharmacy_groups_response_action_1.getPharmacyGroupsResponseAction(groups))];

          case 10:
            _a.sent();

            return [3, 14];

          case 11:
            return [4, get_pharmacy_group_1.getPharmacyGroup(userApi, accessToken)];

          case 12:
            currentGroup = _a.sent();
            return [4, dispatch(pharmacy_group_select_action_1.pharmacyGroupSelectAction(currentGroup))];

          case 13:
            _a.sent();

            _a.label = 14;

          case 14:
            return [4, dispatch(login_response_action_1.loginResponseAction(isAdmin, authProvider.getAccountName()))];

          case 15:
            _a.sent();

            react_native_router_flux_1.Actions[pricing_experience_navigator_screen_names_1.NavigationScreenNames.priceLookupPage].call(thisArg);
            logger_1.Logger.logStatusEvent(logger_1.LoggerEventActionType.authentication, logger_1.LoggerEventStatusType.success, authProvider);
            return [3, 25];

          case 16:
            ex_1 = _a.sent();
            if (!(ex_1 instanceof login_cancelled_error_1.LoginCancelledError)) return [3, 17];
            logger_1.Logger.logStatusEvent(logger_1.LoggerEventActionType.authentication, logger_1.LoggerEventStatusType.cancelled);
            return [3, 24];

          case 17:
            if (!(ex_1 instanceof login_in_progress_error_1.LoginInProgressError)) return [3, 19];
            return [4, dispatch(error_message_show_action_1.errorMessageShowAction(ex_1.message, errors_1.Errors.loginInProgressTitle))];

          case 18:
            _a.sent();

            return [3, 23];

          case 19:
            if (!(authProvider && authProvider.isLoggedIn())) return [3, 21];
            return [4, dispatch(login_incomplete_error_show_action_1.loginIncompleteErrorShowAction(authProvider.getAccountName()))];

          case 20:
            _a.sent();

            return [3, 23];

          case 21:
            return [4, dispatch(error_message_show_action_1.errorMessageShowAction(error_context_1.ErrorContext.login))];

          case 22:
            _a.sent();

            _a.label = 23;

          case 23:
            logger_1.Logger.logException(ex_1);
            logger_1.Logger.logStatusEvent(logger_1.LoggerEventActionType.authentication, logger_1.LoggerEventStatusType.failure, authProvider);
            _a.label = 24;

          case 24:
            return [3, 25];

          case 25:
            return [2];
        }
      });
    });
  });
};